import logger from "utils/logger";
import { PROGRAM_DAY_KEYS } from "features/planner/model/programState";

const PROGRAM_DRAFT_SCHEMA_VERSION = 2;
const PROGRAM_DRAFT_KEY_PREFIX = "gymapp_autosave:v2";

export const getNewProgramDraftIdentity = () => ({ type: "new" });

export const getExistingProgramDraftIdentity = (programId) => ({ type: "program", programId });

export const getProgramDraftStorageKey = (identity) => {
  if (identity?.type === "new") {
    return `${PROGRAM_DRAFT_KEY_PREFIX}:new`;
  }

  if (identity?.type === "program") {
    return `${PROGRAM_DRAFT_KEY_PREFIX}:program:${identity.programId}`;
  }

  return null;
};

const isProgramState = (value) =>
  Boolean(
    value &&
      typeof value === "object" &&
      value.days &&
      PROGRAM_DAY_KEYS.every((dayKey) => Array.isArray(value.days[dayKey]?.slots))
  );

const isMatchingDraftIdentity = (programState, identity) => {
  if (identity?.type === "new") {
    return programState.id === null;
  }

  if (identity?.type === "program") {
    return String(programState.id) === String(identity.programId);
  }

  return false;
};

export const readProgramDraft = (identity) => {
  const key = getProgramDraftStorageKey(identity);
  if (!key) return null;

  const raw = localStorage.getItem(key);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);

    if (
      parsed?.schemaVersion === PROGRAM_DRAFT_SCHEMA_VERSION &&
      isProgramState(parsed.programState) &&
      isMatchingDraftIdentity(parsed.programState, identity)
    ) {
      return parsed.programState;
    }
  } catch (err) {
    logger.error(`Failed to restore ${key}`, err);
  }

  localStorage.removeItem(key);
  return null;
};

export const writeProgramDraft = (identity, programState) => {
  const key = getProgramDraftStorageKey(identity);
  if (!key) return;

  localStorage.setItem(
    key,
    JSON.stringify({
      schemaVersion: PROGRAM_DRAFT_SCHEMA_VERSION,
      updatedAt: new Date().toISOString(),
      programState,
    })
  );
};

export const removeProgramDraft = (identity) => {
  const key = getProgramDraftStorageKey(identity);
  if (!key) return;

  localStorage.removeItem(key);
};
